import { vars } from "plos/src/styles";
import { style } from "@vanilla-extract/css";

export const renewWrapper = style({
  display: "flex",
  flexDirection: "column",
  gap: vars.space.m,
});

export const buttonWrapper = style({
  display: "flex",
  gap: vars.space.xs,
  marginTop: vars.space.xs,
});

export const renewListStyles = style({
  display: "grid",
  gap: vars.space.xs,
});
